/* tslint:disable:max-line-length */
import { FuseNavigationItem } from 'fuseui';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'section.menu.dashboard',
        title: 'Přehled',
        type: 'basic',
        icon: 'heroicons_outline:home',
        link: '/dashboard',
    },
    {
        id: 'section.menu.users',
        title: 'Uživatelé',
        type: 'basic',
        icon: 'heroicons_outline:users',
        link: '/users',
    },
    {
        id: 'section.menu.companies',
        title: 'Firmy',
        type: 'basic',
        icon: 'heroicons_outline:briefcase',
        link: '/companies',
    },
    {
        id: 'section.menu.groups',
        title: 'Skupiny',
        type: 'basic',
        icon: 'heroicons_outline:user-group',
        link: '/groups',
    },
    {
        id: 'section.menu.forms',
        title: 'Listy',
        type: 'basic',
        icon: 'heroicons_outline:clipboard-list',
        link: '/forms',
    },
    {
        id: 'section.menu.stats',
        title: 'Statistiky',
        type: 'basic',
        icon: 'heroicons_outline:presentation-chart-line',
        link: '/logs',
    },
    {
        id: 'section.menu.communications',
        title: 'Notifikace',
        type: 'basic',
        icon: 'heroicons_outline:bell',
        link: '/communications',
    },
    {
        id: 'section.menu.newss',
        title: 'Novinky',
        type: 'basic',
        icon: 'heroicons_outline:rss',
        link: '/news',
    },
    {
        id: 'Flagy',
        title: 'Flagy',
        type: 'basic',
        icon: 'feather:flag',
        link: '/flags',
    },
    {
        id: 'Školení',
        title: 'Školení',
        type: 'basic',
        icon: 'feather:book-open',
        link: '/courses',
    },
    {
        id: 'Položky menu',
        title: 'Položky menu',
        type: 'basic',
        icon: 'heroicons_outline:template',
        link: '/menu',
    },
    {
        id: 'section.menu.app-group-3',
        title: 'Aplikace Sting',
        subtitle: 'section.menu.app-group-3',
        type: 'group',
        children: [
            {
                id: 'section.menu.privacy',
                title: 'Podmínky',
                type: 'basic',
                icon: 'heroicons_outline:information-circle',
                link: '/sign-privacy',
            },
            {
                id: 'section.menu.support',
                title: 'Podpora',
                type: 'basic',
                icon: 'heroicons_outline:question-mark-circle',
                link: '/support',
            },
            {
                id: 'section.menu.changelog',
                title: 'Changelog',
                type: 'basic',
                icon: 'heroicons_outline:newspaper',
                link: '/changelog',
            },
        ],
    },
];

export const futuristicNavigation: FuseNavigationItem[] = [];
export const horizontalNavigation: FuseNavigationItem[] = [];
export const horizontalNavigationNotAdmin: FuseNavigationItem[] = [];
